import { getLoggerLevelsUrl } from "config/paths";

export default token => {
  const fetchOptions = {
    method: "GET",
    mode: "cors",
  };

  return fetch(getLoggerLevelsUrl(token), fetchOptions).then(res => {
    if (res.ok) {
      return res.json();
    }
    throw new Error();
  });
};
